import PropTypes from 'prop-types'

/**
 * @typedef {'idle' | 'loading' | 'succeeded' | 'failed' | 'init'} SliceStatus
 *
 * @typedef {Object} SliceError
 * @property {string} [action] - The action that caused the error.
 * @property {string} [message] - Error message.
 *
 * @typedef {Object} BaseSlice
 * @property {SliceStatus} status - The current status of the slice.
 * @property {SliceError[]} [errors] - An array of errors.
 */

export const sliceStatusPropTypes = PropTypes.oneOf(['idle', 'loading', 'succeeded', 'failed', 'init'])
export const sliceErrorsPropTypes = PropTypes.arrayOf(PropTypes.shape({ message: PropTypes.string }))
export const baseSlicePropTypes = PropTypes.shape({
  status: sliceStatusPropTypes,
  errors: sliceErrorsPropTypes
})
